__turbopack_context__.v({
  "alert": "nS95Ya_alert",
  "backButton": "nS95Ya_backButton",
  "nextButton": "nS95Ya_nextButton",
  "signUpButton": "nS95Ya_signUpButton",
});
